import { AfterViewInit, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Observable, Subject, takeUntil } from 'rxjs';
// import { IPayPalConfig, ICreateOrderRequest } from 'ngx-paypal';
import { environment } from '../../../environments/environment';
import { Product } from "../../shared/classes/product";
import { ProductService } from "../../shared/services/product.service";
import { OrderService } from "../../shared/services/order.service";
import { AccountService } from 'src/app/shared/services/account.service';
import { Router } from '@angular/router';
import { loadStripe, Stripe, StripeCardElement, StripeElements } from '@stripe/stripe-js';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-checkout',
    templateUrl: './checkout.component.html',
    styleUrls: ['./checkout.component.scss']
})
export class CheckoutComponent implements OnInit, AfterViewInit {

    public checkoutForm: UntypedFormGroup;
    public products: Product[] = [];
    // public payPalConfig ? : IPayPalConfig;
    public payment: string = 'Stripe';
    public amount: any;
    profile: any;
    address: any;
    stripe: Stripe | null = null;
    elements: StripeElements | null = null;
    card: StripeCardElement | null = null;
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    processing: boolean = false;

    constructor(private fb: UntypedFormBuilder,
        public productService: ProductService,
        private _changeDetectorRef: ChangeDetectorRef,
        private _accountService: AccountService,
        private router: Router,
        private orderService: OrderService,
        private toastr: ToastrService,
    ) { }

    ngOnInit(): void {
        this.productService.cartItems.subscribe(response => this.products = response);
        this.getTotal.subscribe(amount => this.amount = amount);

        const userProfile = localStorage.getItem('user');
        this.profile = userProfile ? JSON.parse(userProfile) : null;

        this.form();

        this._accountService.getAddressList()
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((res) => {
                this.address = res.find(address => address.is_billing)
                if (this.address) {
                    this.checkoutForm.patchValue({
                        address: this.address.address,
                        country: this.address.country,
                        town: this.address.city,
                        state: this.address.state,
                        postalcode: this.address.zip
                    });
                }
                this._changeDetectorRef.markForCheck();
            });
    }

    async ngAfterViewInit() {
        this.stripe = await loadStripe(environment.stripe_token);

        // Create an instance of Elements
        this.elements = this.stripe.elements();

        // Define custom styling (for text and placeholder)
        const style = {
            base: {
                color: "#32325d",
                fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                fontSmoothing: "antialiased",
                fontSize: "16px",
                "::placeholder": {
                    color: "#aab7c4"
                }
            },
            invalid: {
                color: "#fa755a",
                iconColor: "#fa755a"
            }
        };

        // Create an instance of the card Element with custom styling
        this.card = this.elements.create('card', { style });
        this.card.mount('#card-element');
    }


    form() {
        this.checkoutForm = this.fb.group({
            firstname: [this.profile ? this.profile.f_name : '', [Validators.required, Validators.pattern('[a-zA-Z][a-zA-Z ]+[a-zA-Z]$')]],
            lastname: [this.profile ? this.profile.l_name : '', [Validators.required, Validators.pattern('[a-zA-Z][a-zA-Z ]+[a-zA-Z]$')]],
            phone: [this.profile ? this.profile.phone : '', [Validators.required, Validators.pattern('[0-9]+')]],
            email: [this.profile ? this.profile.email : '', [Validators.required, Validators.email]],
            address: ['', [Validators.required, Validators.maxLength(50)]],
            country: ['USA', Validators.required],
            town: ['', Validators.required],
            state: ['', Validators.required],
            postalcode: ['', Validators.required]
        });
    }

    public get getTotal(): Observable<number> {
        return this.productService.cartTotalAmount();
    }

    async placeOrder() {
        this.processing = true;
        const { paymentMethod, error } = await this.stripe.createPaymentMethod({
            type: 'card',
            card: this.card,
        });

        if (error) {
            this.toastr.warning(error.message);
        }

        const orderData = {
            customer_id: this.profile ? this.profile.id : null,
            guest_id: Number(localStorage.getItem('guest_id')),
            is_guest: this.profile ? 0 : 1,
            payment_method_id: paymentMethod.id,
        };

        this._accountService.placeOrder(orderData).subscribe({
            next: (response) => {
                this.processing = false;
                this.productService.removeCarts();
                this.toastr.success('Your order has been placed successfully', 'Order Confirmed');
                this.router.navigate(['/shop/checkout/success', response.order_ids[0].id]);
            },
            error: (error) => {
                console.error('Error fetching order details:', error);
                this.processing = false;
                this.toastr.error('Failed to fetch order details');
            }
        });
    }

    // Helper function to get address ID
    getAddressIdFromProfileOrForm(): number | null {
        // Return the address ID as a number or null
        return this.profile?.address_id ? Number(this.profile.address_id) : null;
    }
}
